<template>
  <div class="app-inner" @click="handleClick">
    <v-loading></v-loading>
    <ContextMenu></ContextMenu>
    <router-view />
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex';
import ContextMenu from '@/views/commonviews/ContextMenu.vue';
import VLoading from './views/commonviews/VLoading.vue';
export default {
  name: 'App',
  data() {
    return {
      projectMobile: false,
      currentHeight: '',
    };
  },
  components: {
    ContextMenu,
    VLoading,
  },
  created() {
    console.log('app 应用创建！');
    if (self != top) {
      this.$store.commit('setisInIframe', true);
      console.log('程序在iframe中！');
      console.log(localStorage.getItem('origin_userInfo'));
    } else {
      this.$store.commit('setisInIframe', false);
      console.log('程序不在iframe中！');
      this.$store.commit('setLoading', true);
    }

    // 更新客户端视窗大小
    this.updateClientViewSize();
    // 初始化当前场景 默认选择数组第一项
    this.init_CurrentScene();
    // api获取项目信息
    // 挂载监听屏幕尺寸变化
    window.addEventListener('resize', this.onResize);

    window.addEventListener('beforeunload', this.handleShutdownBrowser);
  },
  mounted() {
    setTimeout(() => {
      this.$store.commit('setLoading', false);
    }, 2400);
  },
  computed: {
    userAgent() {
      return navigator.userAgent;
    },
    screenWidth() {
      return this.$store.state.ProjectInfo.ScreenSize.width;
    },
    // screenHeight() {
    //   return this.$store.state.ProjectInfo.ScreenSize.height;
    // },
    // projectIsMobile() {
    //   return this.$store.state.isMobile;
    // },
    ...mapState({
      screenHeight: state => state.ProjectInfo.ScreenSize.height,
      projectIsMobile: state => state.isMobile,
    }),
  },
  watch: {
    userAgent: {
      // deep: true,
      immediate: true,
      handler: function (nV, oV) {
        console.log('访问的端为：', navigator.userAgent);
        this.judgeMobileOrPC(nV);
      },
    },
    screenWidth(nV, oV) {
      if (nV <= 768) {
        this.$store.commit('setIsMobile', true);
      } else {
        this.$store.commit('setIsMobile', false);
      }
    },
    screenHeight(nV, oV) {
      // console.log(nV, 'watch screenHeight');
      if (nV) {
        this.currentHeight = nV;
      }
    },
    projectIsMobile(nv, ov) {
      // console.log(nv, 'watch projectIsMobile');
      if (nv) {
        this.projectMobile = nv;
      }
    },
  },
  unmounted() {
    window.removeEventListener('beforeunload', this.handleShutdownBrowser);
  },
  beforeUnmount() {
    // 卸载监听屏幕尺寸变化
    window.localStorage.removeItem('origin_userInfo');
    window.removeEventListener('resize', this.onResize);
    console.log('app 应用结束！');
  },
  methods: {
    ...mapMutations(['set_ClientViewSize', 'init_CurrentScene']),
    judgeMobileOrPC(userAgent) {
      console.log(userAgent, 'userAgent userAgent');
      if (userAgent.match(/(iPhone|iPod|Android|ios|iOS|iPad|Backerry|WebOS|Symbian|Windows Phone|Phone)/i)) {
        this.$store.commit('setIsMobile', true);
        // alert("手机端访问");
      } else {
        this.$store.commit('setIsMobile', false);
        // alert("PC端访问");
      }
    },
    onResize() {
      this.set_ClientViewSize(this.getClientViewSize());
    },
    handleShutdownBrowser() {
      //window.localStorage.removeItem('origin_userInfo');
      //window.localStorage.removeItem('project_row_id');
    },
    // 获取客户端视窗大小
    getClientViewSize() {
      if (this.projectMobile === true) {
        let width = document.body.clientWidth;
        // let height = document.body.clientHeight;
        let height = Number(this.currentHeight);
        return { width, height };
      } else {
        let width = document.body.clientWidth;
        let height = document.body.clientHeight;
        return { width, height };
      }
    },
    // 打印客户端视窗大小
    logClientViewSize() {
      let { width, height } = this.$store.state.ClientViewSize;
    },
    // 更新客户端视窗大小
    updateClientViewSize() {
      this.set_ClientViewSize(this.getClientViewSize());
      // this.logClientViewSize();
    },
    // 监听鼠标点击 移除右键菜单
    handleClick() {
      this.$store.commit('set_ContextMenu', {
        isOpen: false,
      });
    },
  },
};
</script>

<style lang="scss">
#app {
  .app-inner {
    width: 100%;
    height: 100%;
  }
  font-family: San Francisco, Microsoft Yahei, PingFangSC-Regular, 'sans-serif';
  // font-family: Avenir, Helvetica, Arial, sans-serif;
  // -webkit-font-smoothing: antialiased;
  // -moz-osx-font-smoothing: grayscale;
  overflow: hidden;
  width: 100vw;
  height: 100vh;
  // min-width: 1020px;
}
@import './assets/css/basic.css';
@import './assets/icon/font.css';
</style>
